<template>
  <div v-if="value!==undefined">
    <div class="flex-end" style="margin-bottom:12px" v-if="isInternalPlugin('order_detail_print')">
      <button class="button is-primary" @click="printOrder($refs.orderDetail)">인쇄하기</button>
    </div>

    <div ref="orderDetail">
      <div class="columns is-multiline">
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문 번호">{{ value.order_num }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문 일자">{{ value.created_time }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문자">{{ value.name }}</admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
      <div class="column is-6">
        <div class="box">
          <admin-box-item title="주문자 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="주문자명(ID)">{{ value.name }}({{ value.email }})</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="이메일">{{ value.email }}</admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="휴대전화">{{ value.phone }}</admin-form-item>
              </div>
              <!--<div class="column is-full">
                <admin-form-item :isFlex="true" label="일반전화">
                  {{ value.tphone }}
                </admin-form-item>
              </div>-->
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문 상품 정보">
            <!-- 탭 -->
            <tab :value="tab"
                 style="margin-top:-20px"
                 :options="tabArr"
                 @update:value="selectTab"></tab>

            <admin-form-item label="주문 상품" style="margin-top:12px">
              <table class="delivery-orderproduct-table">
                <thead>
                  <tr>
                    <th style="width:5%">
                      <lp-check-bool :checkedVal.sync="check" @onCheck="clickCheckBoxAll"></lp-check-bool>
                    </th>
                    <th style="width:20%">상품 주문 번호</th>
                    <th style="width:25%">주문 상품</th>
                    <th style="width:10%">옵션 단가</th>
                    <th style="width:5%">수량</th>
                    <th style="width:10%">할인 금액</th>
                    <th style="width:15%">주문 상태</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(op,idx) in order_product" :key="'op-'+idx">
                    <td style="width:5%">
                      <lp-check-bool
                        v-if="checkArr[idx]!==undefined && !op.current_exchange"
                        @onCheck="selectOrderProduct"
                        :checkedVal.sync="checkArr[idx].value"></lp-check-bool>
                    </td>
                    <td style="width:20%">{{ op.id }}</td>
                    <td style="width:25%">
                      <div class="flex">
                        <img :src="op.product.img" style="width:35px;height:35px;margin-right:6px" v-if="op.product.img">
                        <div style="text-align: left">
                          <div v-if="op.order_product_option.length>0">
                            <div>{{ op.product.name }}</div>
                            <div style="color:#C1C1C1;font-size:14px"
                                 v-for="(option, option_idx) in op.order_product_option"
                                 :key="'option-'+option_idx">
                              <span v-if="option.option.option_type===0">기본옵션:</span>
                              <span v-if="option.option.option_type===1">추가옵션:</span>
                              {{ option.option.name }} {{ option.option.price | currency }} X {{ option.quantity }}
                            </div>
                          </div>
                          <div v-else>
                            {{ op.product.name }} {{ op.quantity }}개
                          </div>
                        </div>
                      </div>

                    </td>
                    <td style="width:10%">{{ op.product_price | currency }}</td>
                    <td style="width:5%">{{ op.quantity }}</td>
                    <td style="width:10%">{{ op.discount_price | currency }}</td>
                    <td style="width:15%">{{ op.status_kor }}</td>
                  </tr>
                </tbody>
                <tbody>
                  <tr class="table-result">
                    <td colspan="4" style="width:60%">계</td>
                    <td style="width:5%">{{ calcQuantity }}</td>
                    <td style="width:10%">{{ calcDiscountPrice | currency }}</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </admin-form-item>

            <!-- 일괄 처리 -->
   <!--         <div class="flex-between"
                 style="background-color: #eee; padding: 8px" v-if="!isExchangePage">
              <div class="flex align-center" style="width:100%">
                <span>선택한 주문을</span>
                <span class="select" style="margin-left: 8px">
                  <select v-model="status" @change="e => status=parseInt(e.target.value)">
                    <option value="" disabled selected>주문상태</option>
                    <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
                  </select>
                </span>
                <button class="button" style="margin-left:8px"
                        @click="clickChange">일괄처리</button>
              </div>
            </div>-->

            <div class="flex" style="background-color: #eee; padding: 8px;justify-content: flex-end;width:100%" v-if="tab===0 && isDeliverySuccess">
              <button class="button" @click="requestRefund">반품 접수</button>
              <button class="button" @click="requestExchange">교환 접수</button>
            </div>
            <div class="flex" style="background-color: #eee; padding: 8px;justify-content: flex-end;width:100%" v-if="tab===1 && isRefunding">
              <button class="button" @click="$modal.show('refundModal')">반품 정보 입력</button>
            </div>

            <!-- 교환 상품 -->
            <exchange-product :exchange_order_product.sync="exchange_order_product"
                              :status_arr="exchange_status_arr"
                              v-if="selectedOrderProduct.length>0 && tab===2"></exchange-product>

            <!-- 교환 상품 일괄 처리 -->
            <div v-if="exchange_order_product.length>0"
                 class="btn-group-justify-end"
                 style="background-color: #eee; padding: 8px">
              <!--<div class="flex align-center">
                <span>선택한 주문을</span>
                <span class="select" style="margin-left: 8px">
                  <select v-model="status" @change="e => status=parseInt(e.target.value)">
                    <option value="" disabled selected>주문상태</option>
                    <option :value="item.value" v-for="(item, idx) in status_arr" :key="'status-'+idx">{{ item.label }}</option>
                  </select>
                </span>
                <button class="button" style="margin-left:8px"
                        @click="clickChange">일괄처리</button>
              </div>-->
              <button class="button is-primary" @click="$modal.show('exchangeModal')">교환 정보 입력</button>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full" v-if="value.refund.length>0">
        <div class="box">
          <admin-box-item title="환불 정보">
            <refund-info :refund_id="refund_id"
                         :order="value"
                         v-for="(refund_id, idx) in value.refund" :key="`refund-${idx}`"></refund-info>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full" v-if="value.exchange.length>0">
        <div class="box">
          <admin-box-item title="교환 정보">
            <exchange-info :exchange_id="exchange_id"
                           :order="value"
                           v-for="(exchange_id,idx) in value.exchange" :key="`exchange-${idx}`"></exchange-info>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="box">
          <admin-box-item title="결제 정보">
            <div class="columns is-multiline">
              <div class="column is-4">
                <table class="delivery-order-info">
                  <tbody>
                    <tr>
                      <td class="order-info-title">총 주문 금액</td>
                      <td>{{ value.product_price | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">배송비</td>
                      <td>{{ value.delivery_cost | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">할인 금액</td>
                      <td>{{ value.discount_price + value.coupon_price + value.point | currency }}</td>
                    </tr>
                    <tr>
                      <td class="order-info-title">실 결제 금액</td>
                      <td>{{ value.total_price | currency }}</td>
                    </tr>
                    <tr v-if="isCard">
                      <td class="order-info-title">부분 취소 금액</td>
                      <td>{{ value.cancel_price | currency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="column is-8">
                <table class="delivery-order-info">
                  <tbody>
                  <tr>
                    <td class="order-info-title">결제 수단</td>
                    <td>{{ value.pay_type_kor }}</td>
                  </tr>
                  <!-- 카드 결제 -->
                  <tr v-if="value.pay_type===0">
                    <td class="order-info-title">결제 카드 정보</td>
                    <td>
                      카드사:
                      <span v-if="value.pg_result.CARD_PurchaseName">{{ value.pg_result.CARD_PurchaseName }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_CARD_PURCHASE_NAME }}</span>
                      <br>
                      TID:
                      <span v-if="value.pg_result.tid">{{ value.pg_result.tid }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_TID }}</span>
                    </td>
                  </tr>
                  <tr v-if="value.pay_type===0">
                    <td class="order-info-title">카드 결제 상세 내역</td>
                    <td>카드결제: {{ payDate }} /
                      <span v-if="value.pg_result.TotPrice">{{ value.pg_result.TotPrice | currency }}</span>
                      <span v-else-if="value.pg_result.P_TID">{{ value.pg_result.P_AMT | currency }}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="order-info-title">결제(입금자)</td>
                    <td>{{ value.name }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- 취소 상태 변경 -->
            <div v-if="showPayStatusChangeDiv">
              <div class="flex align-center" style="background-color: #eee; padding: 8px">
                <span></span>
                <span class="select" style="margin-left: 8px">
                  <select v-model="cancelStatus" @change="e => cancelStatus=parseInt(e.target.value)">
                    <option value="" disabled selected>취소 상태 변경</option>
                    <option :value="item.value" v-for="(item, idx) in cancel_status_arr" :key="'status-'+idx">{{ item.label }}</option>
                  </select>
                </span>
                <input class="input full has-text-right"
                       style="margin-left: 8px; width:250px"
                       v-model="cancelPrice"
                       @input="setCancelPrice"
                       v-if="cancelStatus===506"
                       type="number">
                <button class="button" style="margin-left:8px"
                        @click="openCancelModal">취소하기</button>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-full">
        <div class="box">
          <admin-box-item title="배송 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item :isFlex="true" label="수령자명">{{ value.delivery.name }}</admin-form-item>
                <admin-form-item :isFlex="true" label="수령자 휴대전화">{{ value.delivery.phone }}</admin-form-item>
                <admin-form-item :isFlex="true" label="수령자 일반전화">{{ value.delivery.tphone }}</admin-form-item>
                <admin-form-item :isFlex="true" label="배송주소">{{ value.delivery.address }}</admin-form-item>
                <admin-form-item :isFlex="true" label="송장번호"></admin-form-item>
                <admin-form-item :isFlex="true" label="배송메모">{{ value.delivery.memo }}</admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    </div>

    <!-- 전체 취소 모달 -->
    <modal name="allCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        전체 취소 하시겠습니까?
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="confirmCancel">확인</button>
        </div>
      </div>
    </modal>

    <!-- 부분 취소 모달 -->
    <modal name="partCancelModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        부분 취소 하시겠습니까?
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="confirmCancel">확인</button>
        </div>
      </div>
    </modal>

    <!-- 환불 철회 모달 -->
    <modal name="cancelRefundModal" :adaptive="true" height="auto" class="modal-style">
      <admin-box-item title="반품 요청 철회" :useTab="false" class="lp-modal-wrapper">
        <div>반품 요청을 철회하면 이전 상태로 돌아갑니다. 철회 하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('cancelRefundModal')">취소</button>
          <button class="button is-primary" @click="confirmModal('cancelRefundModal')">확인</button>
        </div>
      </admin-box-item>
    </modal>

    <!-- 환불 모달 -->
    <modal name="refundModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <order-refund class="lp-modal-wrapper"
                    :order="value"
                    :refund_id="selectedRefundId"
                    @confirm="confirm('refundModal')"
                    @close="$modal.hide('refundModal')"></order-refund>
    </modal>

    <!-- 교환 정보 입력 모달 -->
    <modal name="exchangeModal" :adaptive="true" :width="800" height="auto" class="modal-style">
      <order-exchange class="lp-modal-wrapper"
                      :order="value"
                      :order_product="selectedOrderProduct"
                      :exchange_order_product="exchange_order_product"
                      @confirm="confirm('exchangeModal')"
                      @close="$modal.hide('exchangeModal')"></order-exchange>
    </modal>
  </div>
</template>

<script>
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import moment from 'moment';
  import OrderRefund from "../components/OrderRefund";
  import DeliveryMixin from "@/mixins/DeliveryMixin"
  import Tab from "../../../module/common/Tab";
  import ExchangeProduct from "../components/ExchangeProduct";
  import OrderExchange from "../components/OrderExchange";
  import ExchangeInfo from "../components/ExchangeInfo";
  import RefundInfo from "../components/RefundInfo";

  export default {
    components: {
      RefundInfo,
      ExchangeInfo,
      OrderExchange,
      ExchangeProduct,
      Tab,
      OrderRefund,
      LpCheckBool},
    name: "order-detail",
    mixins: [
      DeliveryMixin
    ],
    data() {
      return {
        value: undefined,
        // tableItems: 원본, order_product: 원본에서 필터링 된 것
        order_product: [],
        calcTotalPrice: 0,
        calcDiscountPrice: 0,
        calcQuantity: 0,
        check: false,
        // 일괄로 변경할 상태
        status: 0,
        status_arr: [],
        // 취소할 상태
        cancelStatus:0,
        cancel_status_arr: [
          {label:'전체취소',value:500},
          {label:'부분취소',value:506},
        ],
        // 부분 취소할 금액
        cancelPrice: 0,
        optionArr: [],
        tab: 0,
        start_status: 0,
        end_status: 0,
        selectedRefundId: 0,
        // 선택된 주문 상품
        selectedOrderProduct: [],
        // 교환 상품
        exchange_order_product: [],
        // 교환 상태값
        exchange_status_arr: []
      }
    },
    created() {
      this.getDetail();
      this.getStatusList();
    },
    computed: {
      isDeliverySuccess () {
        let enable = false;
        this.order_product.forEach(item => {
          // 배송 완료 상태일 경우 활성화
          if(item.status===302) {
            enable = true;
          }
        })
        return enable;
      },
      // 환불 정보 입력 버튼 활성화 여부
      isRefunding () {
        let enable = false;
        this.order_product.forEach(item => {
          // 반품 검사중 상태일 경우 활성화
          if(item.status===702 || item.status===703) {
            enable = true;
          }
        })
        return enable;
      },
      isRefundPage () {
        let page = this.$route.query.page;
        let page_list = ['OrderListRefundAll', 'OrderListRefundNew', 'OrderListReturnAll',
          'OrderListReturning', 'OrderListReturnNew'];
        return page_list.indexOf(page) > -1;
      },
      isExchangePage () {
        let page = this.$route.query.page;
        let page_list = ['OrderListExchangeNew', 'OrderListExchangeAll', 'OrderListExchanging',
          'OrderListExchangeSuccess', 'OrderListExchangeGoods', 'OrderListExchangeDeliveryNew',
          'OrderListExchangeDeliveryAll', 'OrderListExchangeSettle'];
        return page_list.indexOf(page) > -1;
      },
      showPayStatusChangeDiv () {
        if(this.isCard) {
          // 전체 취소 또는 환불 없음 상태 노출 안함
          return !(this.value.is_cancel_all || this.value.no_refund);
        }
        else {
          return false;
        }
      },
      // 카드 결제 유무
      isCard() {
        return this.value.pay_type !== 2;
      },
      payDate() {
        let date = '';
        if(this.value.pg_result.applDate) {
          date = `${this.value.pg_result.applDate} ${this.value.pg_result.applTime}`;
          return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
        else {
          date = this.value.pg_result.P_AUTH_DT
          return date
        }
      },

    },
    methods: {
      // 주문 상품 선택
      selectOrderProduct () {
        let id_list = this.getCheckedArr();
        let selected = [];
        for(let i=0; i<id_list.length; i++) {
          let op = find(this.order_product, 'id', id_list[i]);
          // console.log(op)
          if(op) selected.push(op);
        }
        this.selectedOrderProduct = selected;
      },
      // 반품 접수
      requestRefund() {
        this.status = 700;
        this.clickChange();
      },
      // 교환 접수
      requestExchange () {
        this.status = 600;
        this.clickChange();
      },
      selectTab (value) {
        this.tab = value;
        let tableItems = [];
        // 교환 예외처리
        if(this.tab!==2) {
          this.selectedOrderProduct = [];
          this.exchange_order_product = [];
        }
        // 전체
        if(this.tab===0) {
          this.start_status = 0;
          this.end_status = 100000;
        }
        // 반품
        else if(this.tab===1) {
          this.start_status = 700;
          this.end_status = 706;
        }
        // 교환
        else if(this.tab===2) {
          this.start_status = 600;
          this.end_status = 609;
        }
        tableItems = this.tableItems.filter(item => {
          return item.status>=this.start_status &&item.status<=this.end_status
        })
        this.order_product = tableItems;
        let checkArr = [];
        for (let i = 0; i < this.order_product.length; i++) {
          checkArr.push({id: this.order_product[i].id, value: false})
        }
        this.checkArr = checkArr;
      },
      confirm (modal_name) {
        this.getDetail();
        this.$modal.hide(modal_name);
        if(modal_name==='exchangeModal') {
          this.selectedOrderProduct = [];
          this.exchange_order_product = [];
        }
      },
      // 상태값 목록
      getStatusList(){
        let page = this.$route.query.page;
        if(!page) return;
        this.$axios.get(this.getUrl(`delivery/order/status?page=${page}`)).then(res=>{
          if(res.status === 200){
            this.status_arr = res.data;
          }
        })
      },
      // 체크박스 일괄 선택
      clickCheckBoxAll(value) {
        this.checkArr.forEach(item => {
          item.value = value;
        })

        this.selectOrderProduct();

      },
      getDetail() {
        this.$axios.get(this.getUrl(`delivery/order/${this.$route.query.id}`)).then(res=> {
          this.value = res.data;
          let tableItems = res.data.order_product;
          let tableList = [];
          for(let i = 0; i < tableItems.length; i++) {
            tableList.push({id: tableItems[i].id, value: false});
          }
          this.checkArr = tableList;
          this.order_product = tableItems;
          // tableItems: 원본 데이터
          // order_product: tableItems를 필터링한 데이터
          this.tableItems = tableItems;


          this.calcTotal();
          /*if(this.isCard) {
            let status = find(this.status_arr, 'value', 504);
            if(status===undefined) this.status_arr.push({label:'취소완료(환불완료)',value:504});
          }
          else {
            let status = find(this.status_arr, 'value', 503);
            if(status===undefined) this.status_arr.push({label:'취소완료(입금전 주문취소)',value:503});
          }*/

          // tabArr 초기화
          let back_count = 0;
          let exchange_count = 0;
          for(let x=0; x<this.order_product.length; x++) {
            let op = this.order_product[x];
            // 반품
            if(op.status>=700 && op.status<=706) {
              back_count += 1
            }
            // 교환
            else if(op.status>=600 && op.status<=609) {
              exchange_count += 1
            }
          }
          let tabArr = [];
          tabArr.push({label:`주문내역(${this.order_product.length})`, value: 0});
          tabArr.push({label:`반품(${back_count})`, value: 1});
          tabArr.push({label:`교환(${exchange_count})`, value: 2});
          this.tabArr = tabArr;

          let page = this.$route.query.page;
          // 교환 검사 완료 내역에서 교환 상품 준비중 처리할때 예외처리
          if(page==='OrderListExchangeSuccess') {
            this.selectTab(2);
            if(this.value.exchange.length===0) {
              this.toast('교환 배송할 상품을 추가 해주세요.');
            }
          }

          // 반품 페이지에서 넘어왔을 경우 반품 탭으로 이동
          if(page==='OrderListReturning' || page=== 'OrderListRefundNew') {
            this.selectTab(1);
            if(this.value.refund.length===0) {
              this.toast('반품할 상품을 추가 해주세요.');
            }
          }

        })
      },
      calcTotal() {
        let total_price = 0;
        let discount_price = 0;
        let quantity = 0;
        this.order_product.forEach(op=> {
          quantity += op.quantity;
          discount_price += op.discount_price;
          total_price += op.total_price;
        })
        this.calcTotalPrice = total_price;
        this.calcDiscountPrice = discount_price;
        this.calcQuantity = quantity;
      },
      // 취소, 부분취소
      openCancelModal() {
        if(this.cancelStatus===500) {
          if(this.value.cancel_price>0) {
            this.toast('부분취소를 하여 전체취소가 불가능합니다.');
            this.$modal.hide('allCancelModal');
          }
          else this.$modal.show('allCancelModal');
        }
        else if(this.cancelStatus===506) {
          this.$modal.show('partCancelModal');
        }
      },
      // 부분 취소 금액 입력
      setCancelPrice(e) {
        let price = parseInt(e.target.value);
        this.cancelPrice = price;
      },
      confirmCancel() {
        // 전체 취소
        if(this.cancelStatus===500) {
          // let url = `http://localhost:8000/user/${this.user.user_id}/delivery/order/${this.card.id}/status/change`;
          let url = `delivery/order/${this.$route.query.id}/status/change`;
          this.$axios.post(this.getUrl(url), {
            status: 500
          }).then(res=> {
            if(res.status===200) {
              this.toast('전체 취소가 완료되었습니다.');
              this.$modal.hide('allCancelModal');
              this.getDetail();
            }
          }).catch(error => {
            this.toast(error.response.data.message);
            this.$modal.hide('allCancelModal');
          });
        }
        // 부분 취소
        else if(this.cancelStatus===506) {
          let url = `delivery/order/${this.$route.query.id}/cancelprice`;
          // let url = `http://localhost:8000/admin/delivery/order/${this.$route.query.id}/cancelprice`;
          this.$axios.post(this.getUrl(url), {
            cancel_price: this.cancelPrice
          }).then(res=> {
            if(res.status===200) {
              this.toast('부분 취소가 완료되었습니다.');
              this.$modal.hide('partCancelModal');
              this.getDetail();
            }
          }).catch(error=> {
            this.toast(error.response.data.message);
            this.$modal.hide('partCancelModal');
            this.getDetail();
          })
        }
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  .delivery-orderproduct-table
  .delivery-order-info
    width 100%

  .delivery-orderproduct-table th
    background-color #eee

  .delivery-orderproduct-table th
  .delivery-orderproduct-table td
  .delivery-order-info td
    text-align center !important
    border 1px solid #e0d9d9
    padding 6px
    vertical-align middle !important

  .delivery-orderproduct-table .table-result
    background-color #EBEAE4

  .delivery-order-info .order-info-title
  .order-info-title
    background-color #eee
</style>
